import React, { FC } from 'react';
import {
    Grid
} from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

const ListTableLoader: FC = (): JSX.Element => {
    return (<Grid container direction="column" style={{ padding: 20 }}>
        <Skeleton animation="wave" height={100} />
        <Skeleton animation="wave" height={100} />
    </Grid>)
}

export default ListTableLoader;